import type {
  ApiSuccess,
  CountryCode,
  LegalAcceptResult,
  LegalLocale,
  LegalPending,
  PublicLegalDoc,
} from '@capsico/contracts';
import { api } from './client';

/* W21 legal: documents to accept again (blocking sheet), accepting them, and reading a document. */

/** Documents this customer must accept again, in the app language (English when not published). */
export async function fetchLegalPending(locale: LegalLocale): Promise<LegalPending> {
  const res = await api.get<ApiSuccess<LegalPending>>('/v1/legal/pending', {
    params: { locale },
  });
  return res.data.data;
}

/** Records the acceptance of these document versions (once per person and version). */
export async function acceptLegal(documentIds: string[]): Promise<LegalAcceptResult> {
  const res = await api.post<ApiSuccess<LegalAcceptResult>>('/v1/legal/accept', { documentIds });
  return res.data.data;
}

/** One published document from the public read API (no sign-in needed). */
export async function fetchLegalDoc(
  slug: string,
  country: CountryCode,
  lang: LegalLocale,
): Promise<PublicLegalDoc> {
  const res = await api.get<ApiSuccess<PublicLegalDoc>>(
    `/v1/public/legal/${encodeURIComponent(slug)}`,
    { params: { country, lang } },
  );
  return res.data.data;
}
